import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Modal from '../../components/Render/Modal/Modal';
import TeamMember from '../../components/ListEntity/Entities/TeamMember';
import ListEntity from '../../components/ListEntity/List';
import TextSection from '../../components/ListEntity/TextSection';
import LayoutSection from '../../components/layout-section';
import Form from '../../forms/team-member';
import AboutForm from '../../forms/about/AboutForm';
import * as ActionsTeam from '../../redux/modules/team';
import * as ActionsAbout from '../../redux/modules/text';
import { IMAGES_REPO } from '../../config';

class General extends PureComponent {
  state = { isOpenHome: false, isOpenTeam: false };

  getData() {
    this.props.getTeam();
    this.props.getAbout('about');
  }

  componentWillMount() {
    this.getData()
  }

  removeTeamMember(info) {
    if (info.id > 0) {
      const { getTeam, delTeam } = this.props;
      delTeam(info.id).then(() => {
        getTeam();
      });
    }
  }

  toggleOpenHomeModal(data = {}) {
    this.setState({ isOpenHome: !this.state.isOpenHome, data });
  }


  toggleOpenTeamModal(data = { type: 'person' }) {
    this.setState({ isOpenTeam: !this.state.isOpenTeam, data });
  }

  render() {
    const { team, text } = this.props;

    console.log(text.values)
    return (
      <div className="contacts-container container">

        <div>
          <h1>About</h1>
        </div>

        <LayoutSection
          isFetching={text.isFetching}
          title="About Us">
          <TextSection
            editAction={() => {
              this.toggleOpenHomeModal(text.values);
            }}>
            <div className="about">
              <div className="about__images">
                <img className="img" src={`${IMAGES_REPO}${text.values.photo2}`}/>
                <img className="img" src={`${IMAGES_REPO}${text.values.photo1}`}/>
              </div>
              <div dangerouslySetInnerHTML={{ __html: text.values.body }}/>
            </div>
          </TextSection>
        </LayoutSection>

        <LayoutSection
          isFetching={team.isFetching}
          title="Team">
          <ListEntity
            number={3}
            component={TeamMember}
            removeAction={(index) => {
              this.removeTeamMember(team.values[index])
            }}
            editAction={(index) => {
              this.toggleOpenTeamModal(team.values[index]);
            }}
            addAction={() => {
              this.toggleOpenTeamModal();
            }}
            values={team.values}/>
        </LayoutSection>

        <div className="contacts-container__modal">
          <Modal
            toogle={this.toggleOpenHomeModal.bind(this)}
            isOpen={this.state.isOpenHome}>
            <AboutForm
              defaultValues={this.state.data}
              close={this.toggleOpenHomeModal.bind(this)}/>
          </Modal>

          <Modal
            toogle={this.toggleOpenTeamModal.bind(this)}
            isOpen={this.state.isOpenTeam}>
            <Form
              defaultValues={this.state.data}
              close={this.toggleOpenTeamModal.bind(this)}/>
          </Modal>
        </div>
      </div>
    );
  }
}

General.propTypes = {};
General.defaultProps = {};

export default connect(
  (state) => {
    return {
      team: state.team,
      text: state.text
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getTeam: ActionsTeam.get,
        delTeam: ActionsTeam.del,
        getAbout: ActionsAbout.get
      }, dispatch);
  }
)(General);



// WEBPACK FOOTER //
// ./src/containers/about/About.js